/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { hubSpotLinkShow } from '../../axios/hubSpotLinkShow'
import type {
	HubSpotLinkShowError,
	HubSpotLinkShowPathParams,
	HubSpotLinkShowResponse,
} from '../../types/HubSpotLinkShow'

export const hubSpotLinkShowQueryKey = (organisation: HubSpotLinkShowPathParams['organisation']) =>
	[{ url: '/:organisation/hubspot', params: { organisation } }] as const

export type HubSpotLinkShowQueryKey = ReturnType<typeof hubSpotLinkShowQueryKey>

/** @see backend/nexus/modules/SupplyChain/Http/Controllers/HubSpotLinkController.php HubSpotLinkController::show */
export function hubSpotLinkShowQueryOptions(
	organisation: HubSpotLinkShowPathParams['organisation'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		HubSpotLinkShowResponse,
		AxiosError<HubSpotLinkShowError>,
		HubSpotLinkShowResponse,
		HubSpotLinkShowQueryKey
	>({
		queryKey: hubSpotLinkShowQueryKey(organisation),
		queryFn: ({ signal }) => hubSpotLinkShow(organisation, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/SupplyChain/Http/Controllers/HubSpotLinkController.php HubSpotLinkController::show */
export function useHubSpotLinkShow<TSelectData = HubSpotLinkShowResponse>(
	organisation: HubSpotLinkShowPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					HubSpotLinkShowResponse,
					AxiosError<HubSpotLinkShowError>,
					TSelectData,
					HubSpotLinkShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<HubSpotLinkShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...hubSpotLinkShowQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/SupplyChain/Http/Controllers/HubSpotLinkController.php HubSpotLinkController::show */
export function useHubSpotLinkShowSuspense<TSelectData = HubSpotLinkShowResponse>(
	organisation: HubSpotLinkShowPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					HubSpotLinkShowResponse,
					AxiosError<HubSpotLinkShowError>,
					TSelectData,
					HubSpotLinkShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<HubSpotLinkShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...hubSpotLinkShowQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
